// import RFBestDeal from './BestDeal-F.png';
const RFBestDeal = '/media/relief-factor-quickstart-guide.png';
// import RFSubSaveOffer2 from './relief-factor-60-vitd.png';
const RFSubSaveOffer2 = '/media/relief-factor-60-vitd.png';
// import RFSingleOrder from './relief-factor-60.png';
const RFSingleOrder = '/media/relief-factor-60.png';
// import RFEnergy from './relief-factor-energy.png';
const RFEnergy = '/media/relief-factor-energy.png';
// import RFCalm from './relief-factor-calm.png';
const RFCalm = '/media/relief-factor-calm.png';
const RFBug = '/media/rf-bug.png';
// const RFShareLogo = '/media/relief-factor-share-logo.png';
const RFShareLogo = '/media/og-image.png';
const SLPGaba = '/media/gaba.jpg';
const SLPLtheanine = '/media/l-theanine.jpg';
const SLPMelatonin = '/media/melatonin.jpg';
const SLPVitaminD = '/media/vitamin-d3.jpg';
import SLPWhySleepBG from './sleeping.jpg';
import SLPCloud from './clouds.jpg';
// import RFSleep from './relief-factor-sleep.png';
const RFSleep = '/media/relief-factor-sleep.png';
// import VitaminD from './Shield-VitD.jpg';
const VitamindBottle = '/media/products/vitamin-d3.webp';
const VitaminD = '/media/vitamin-d3.webp';
// import VitaminC from './Shield-VitC.jpg';
// const VitaminC = '/media/bottle-vitamin-c.jpg';
const VitaminC = '/media/vitamin-c.webp';
const turmericImageStr = '/media/turmeric.jpg';
const omega3 = '/media/omega-3.png';
// const icariin = '/media/icariin.png';
// const curcumin = '/media/curcumin.png';
// const resveratrol = '/media/resveratrol.png';
const mkOmega3 = '/media/feel-brand-new/omega-3.png';
const mkIcariin = '/media/feel-brand-new/icariin.png';
const mkTurmeric = '/media/feel-brand-new/turmeric.png';
const mkResveratrol = '/media/feel-brand-new/resveratrol.png';
const happyWomen = '/media/feel-brand-new/happy-women.png';
const researchImage = '/media/relief-factor-research.webp';
const RFQSTablets = '/media/relief-factor-qs-pills.png';
import { productsKeyConstants } from '../../config';
const yourSolutionImage = '/media/your-solution.png';
const quickstartImage = '/media/relief-factor-quickstart.png';
const happyCoupleImage = '/media/happy-couple.webp';
const joggingGuysImage = '/media/friends-jogging.webp';
const sleepingCoupleImage = '/media/sleeping-couple.webp';
const turmericBowlImage = '/media/turmeric-bowl.jpg';
const veteranImage = '/media/veteran-owned-business.png';
const reviewImage = '/media/portrait.jpg';
const rfFooterLogo = '/media/footer/rfc-logo-vert-all-white.png';
// for New site
const veteranImg = '/media/Veteran.png';
const painRelief = '/media/products/rf-pain-relief.webp';
const goFactor = '/media/products/rf-go-factor.webp';
const zenFactor = '/media/products/rf-zen-factor.webp';
const zFactor = '/media/products/rf-z-factor.webp';
const leaf1 = '/media/footer/Leaf-1.png';
const leaf2 = '/media/footer/Leaf-2.png';
const leaf3 = '/media/footer/Leaf-3.png';
const leaf4 = '/media/footer/Leaf-4.png';
const whyReliefFactorImg = '/media/why-relieffactor.webp';
const whyReliefFactorImgBlur = '/media/why-relieffactor-blur.webp';
const customerStoriesImg = '/media/customer-stories.webp';
const miniCartRelief = '/media/products/mini-cart-relief.png';
const resourceArticle = '/media/resource-article.png';
const resourceArticleBody = '/media/resource-article-body.png';
const rfLogoPng = '/media/RF-icon.png';
const pillsWithShadow = '/media/products/pills-with-shadow.png';
const pillWithShadow = '/media/products/pill-with-shadow.png';
const pillsPacket = '/media/products/pills-packet.png';
const rfPainRelief = '/media/products/rf-pain-relief.webp';
const rfThinkFactor = '/media/products/think-factor.webp';
const rfZenFactor = '/media/products/rf-zen-factor.webp';
const rfZFactor = '/media/products/rf-z-factor.webp';
const rfGoFactor = '/media/products/rf-go-factor.webp';
const deAntioxidants = '/media/product-gallery/acb/antioxidants-bottle.webp';
const rfFullSpectrumE = '/media/product-gallery/fse/full-spectrum-e.webp';
const immuneFactor = '/media/product-gallery/immune/immune-factor-bottle.webp';
const nAcetyleCystine = '/media/product-gallery/nac/nac-bottle.webp';
const howItWorksImg1 = '/media/howItWorks/img1.webp';
const howItWorksImg2 = '/media/howItWorks/img2.webp';
const howItWorksImg3 = '/media/howItWorks/img3.webp';
const graph_howItWorks = '/media/howItWorks/graph.webp';
const Icariin = '/media/howItWorks/Icariin.webp';
const Resveratrol = '/media/howItWorks/Resveratrol.webp';
const Turmeric = '/media/howItWorks/Turmeric.webp';
const Omega3 = '/media/howItWorks/Omega3.webp';
const fullBleedImg = '/media/howItWorks/fullBleedFullImg.jpg';
const fullBleedImgSm = '/media/howItWorks/fullBleedSmImg.webp';
const fullBleedImgmd = '/media/howItWorks/fullBleedFullImgMd.jpg';
const rfZenFactor1 = '/media/products/rf-zen-factor-1.webp';
const rfZFactor1 = '/media/products/rf-z-factor-1.webp';
const rfGoFactor1 = '/media/products/rf-go-factor-1.webp';

const resveratrolImg = '/media/ingredients/Resveratrol.png';
const fishOilImg = '/media/ingredients/Fish-oil.png';
const turmericImg = '/media/ingredients/turmeric.png';
const icariinImg = '/media/ingredients/icariin.png';

const timelineImg1 = '/media/timeline-img-1.webp';
const timelineImg2 = '/media/timeline-img-2.webp';
const timelineImg3 = '/media/timeline-img-3.webp';

const testimonialsReliefImg = '/media/testimonials/testimonial-art-relief.jpg';
const testimonialsZenImg = '/media/testimonials/testimonial-drew-zen.jpg';
const testimonialsGoImg = '/media/testimonials/testimonial-melonie-go.jpg';
const testimonialszImg = '/media/testimonials/testimonial-brenda-z.jpg';

const RFQSTabletsOld = '/media/relief-factor-qs-pills.webp';
const RF_Icon = '/media/rf-icon.png';

// Ingredients
const curcumin = '/media/ingredients/rf/curcumin.png';
const icariin = '/media/ingredients/rf/icariin.png';
const omega = '/media/ingredients/rf/omega.png';
const resveratrol = '/media/ingredients/rf/resveratrol.png';

const taurine = '/media/ingredients/go/taurine.png';
const bcomplex = '/media/ingredients/go/b-complex.png';
const caffeine = '/media/ingredients/go/caffeine.png';

const phosphatidylserine = '/media/ingredients/zen/phosphatidylserine.png';
const passionflower = '/media/ingredients/zen/passion-flower.png';

const ltheanine = '/media/ingredients/z/l-theanine.png';
const vitamind = '/media/ingredients/z/vitamin-d.png';
const melatonin = '/media/ingredients/z/melatonin.png';
const gaba = '/media/ingredients/z/gaba.png';
// Ingredients
const echinaceaAngustipholia =
  '/media/ingredients/immune/echinacea-angustifolia.webp';
const andrographis = '/media/ingredients/immune/andrographis.webp';
const echinaceaPurpurea = '/media/ingredients/immune/echinacea-purpurea.webp';
const berberis = '/media/ingredients/immune/berberis-aristata.webp';
const astragalus = '/media/ingredients/immune/astragalus.webp';
const cticoline = '/media/ingredients/think-factor/cticoline.webp';
const lutein = '/media/ingredients/think-factor/lutein.webp';
const zeaxanthin = '/media/ingredients/think-factor/zeaxanthin.webp';
const choline = '/media/ingredients/b-complex/choline.webp';
const folate = '/media/ingredients/b-complex/folate.webp';
const inositol = '/media/ingredients/b-complex/inositol.webp';
const niacin = '/media/ingredients/b-complex/niacin.webp';
const paraAminobenzoic = '/media/ingredients/b-complex/para-aminobenzoic.webp';
const riboflavin = '/media/ingredients/b-complex/riboflavin.webp';
const thiamin = '/media/ingredients/b-complex/thiamin.webp';
const vitaminB6 = '/media/ingredients/b-complex/vitamin-b6.webp';
const vitaminB12 = '/media/ingredients/b-complex/vitamin-b12.webp';
const ascorbicAcid =
  '/media/ingredients/b-complex/vitamin-c-ascorbic-acid.webp';
const pantothenic = '/media/ingredients/b-complex/pantothenic-acid.webp';
const biotin = '/media/ingredients/b-complex/biotin.webp';
const molybdenum = '/media/ingredients/nac/molybdenum.webp';
const AcetyleCystine = '/media/ingredients/nac/n-acetyl-cysteine.webp';
const selenium = '/media/ingredients/nac/selenium.webp';
const CoQ10 = '/media/ingredients/red-yeast-rice/ryr-CoQ10.webp';
const redYeastExtract = '/media/ingredients/red-yeast-rice/ryr-extract.webp';
const VEPfolate = '/media/ingredients/vessel-protection/folate.webp';
const VEPvitaminB6 = '/media/ingredients/vessel-protection/vep-vitamin-b6.webp';
const VEPvitaminB12 =
  '/media/ingredients/vessel-protection/vep-vitamin-b12.webp';
const berberisAristata = '/media/ingredients/berberine/berberis-aristata.webp';
const aztecMarigold = '/media/ingredients/fse/aztec-marigold.webp';
const Selenium = '/media/ingredients/fse/selenium.webp';
const bitartrate = '/media/ingredients/fse/bitartrate.webp';
const dunaliella = '/media/ingredients/fse/dunaliella.webp';
const tocotrienol = '/media/ingredients/fse/tocotrienol.webp';
const vitaminA = '/media/ingredients/fse/vitamin-a.webp';
const vitaminE = '/media/ingredients/fse/vitamin-e.webp';
const vitaminD = '/media/ingredients/vit-d3/vitamin-d.webp';
const vitaminK2 = '/media/ingredients/vit-d3/vitamin-k2.webp';
const calcium = '/media/ingredients/antioxidants/calcium.webp';
const catalase = '/media/ingredients/antioxidants/catalase.webp';
const bioflavonoid =
  '/media/ingredients/antioxidants/citrus-bioflavonoids.webp';
const greenTea = '/media/ingredients/antioxidants/greentea-leaf.webp';
const hesperidin = '/media/ingredients/antioxidants/hesperidin.webp';
const magnesium = '/media/ingredients/antioxidants/magnesium.webp';
const quercetin = '/media/ingredients/antioxidants/quercetin.webp';
const antioxidantResveratrol =
  '/media/ingredients/antioxidants/resveratrol.webp';
const rutin = '/media/ingredients/antioxidants/rutin.webp';
const sod = '/media/ingredients/antioxidants/sod.webp';
const vitaminC = '/media/ingredients/antioxidants/vitamin-c.webp';

// Story
const sufferingWithPain = '/media/story/rf/suffering-with-pain.webp';
const findRelief = '/media/story/rf/find-relief.jpg';
const discoverReliefFactor = '/media/story/rf/discover-relief-factor.jpg';

const stressedOut = '/media/story/zen/stressed-out.webp';
const meditationPose = '/media/story/zen/meditation-pose.jpg';
const zenSuccess = '/media/story/zen/zen-success.webp';

const noEnergy = '/media/story/go/no-energy.webp';
const twoEnergyDrinks = '/media/story/go/two-energy-drinks.jpg';
const studying = '/media/story/go/studying.jpg';

const sleepless = '/media/story/z/sleepless.webp';
const sleeping = '/media/story/z/sleeping.jpg';
const rejuvenated = '/media/story/z/rejuvenated.jpg';
// Story

//Boday
const painReliefBody = '/media/body/painrelief.png';
const zenFactorBody = '/media/body/zenFactor.png';
const goFactorBody = '/media/body/goFactor.png';
const zFactorBody = '/media/body/zFactor.png';

//Review
const reviewHeaderDesktop = '/media/review/review-header-desktop.jpg';
const reviewHeaderTab = '/media/review/review-header-tab.jpg';
const reviewHeaderMobile = '/media/review/review-header-mobile.jpg';

//Support
const supportHeaderDesktop = '/media/support/hero-lg.png';
const supportHeaderTab = '/media/support/hero-md.jpg';

// Getting Started
const gettingStartedRFPills =
  '/media/product-gallery/rf/getting-started/relief-factor-pills.jpg';

const pillTwo = '/media/products/pill-two.png';
const pillFive = '/media/products/pill-five.png';

const testimonialFullImg1 = '/media/testimonials/drew-with-son.jpg';
const testimonialMbImg1 = '/media/testimonials/testimonialMbImg2.webp';
const testimonialFullImg2 = '/media/testimonials/dale-hiking.jpg';
const testimonialFullImg3 = '/media/testimonials/sandy-at-beach.jpg';
const testImg1 = '/media/testimonials/drewWithSon.jpg';
const testImg2 = '/media/testimonials/drewWithSonTabImg.jpg';
const testImg3 = '/media/testimonials/640-1.jpg';
const testImg4 = '/media/testimonials/daleHiking.jpg';
const testImg5 = '/media/testimonials/daleHikingTabImg2.jpg';
const testImg6 = '/media/testimonials/daleHikingMbImg.jpg';
const testImg7 = '/media/testimonials/sandyAtBeach.jpg';
const testImg8 = '/media/testimonials/1920-2.jpg';
const testImg9 = '/media/testimonials/sandyAtBeachMbImg.jpg';

const newVitaminC = '/media/products/vitamin-c.webp';
const newVitaminD = '/media/products/vitamin-d.webp';

//overview PDP new product
const thinkfactorOverviewBackground =
  '/media/overview/think-factor-overview.webp';
const antioxidantOverviewBackground = '/media/overview/Antioxidants.webp';
const fullSpectrumOverviewBackground = '/media/overview/full-spectrum-E.webp';
const immuneOverviewBackground = '/media/overview/Immune-Factors-cta.webp';
const immuneOverviewBottle = '/media/overview/immune-factors-ov-bottle.webp';

const nAcetyleOverviewBackground = '/media/overview/NAC.webp';
const berberineOverviewBackground = '/media/overview/Berberine.webp';
const vitBOverviewBackground = '/media/overview/Vitamin-B-Complex.webp';
const redYeastOverviewBackground = '/media/overview/red-yeast-rice.webp';
const vesselProtectOverviewBackground =
  '/media/overview/vessel-protection.webp';
const vitDK2OverviewBackground = '/media/overview/Vitamin-D-2000.webp';
const vitDK5OverviewBackground = '/media/overview/Vitamin-D-5000.webp';

//How it works 10 new Products
const thinkHowItWrks = '/media/main-benefits/howItWorks.webp';
// const thinkHowItWrks = '/media/main-benefits/wellness-yoga.webp';
const acbHowItWrks = '/media/main-benefits/howItWorks.webp';
const fscHowItWrks = '/media/main-benefits/wellness-sunset.webp';
const imfHowItWrks = '/media/main-benefits/howItWorks.webp';
const nacHowItWrks = '/media/main-benefits/wellness-yoga.webp';
const berHowItWrks = '/media/main-benefits/wellness-yoga.webp';
const vbcHowItWrks = '/media/main-benefits/biking-view.webp';
const ryrHowItWrks = '/media/main-benefits/wellness-sunset.webp';
const vepHowItWrks = '/media/main-benefits/benefits-hiking.webp';
const dk2HowItWrks = '/media/main-benefits/benefits-hiking.webp';
const dk5HowItWrks = '/media/main-benefits/benefits-hiking.webp';

//Price section PDP new products
const tnkPriceSection = '/media/price-and-value/price-and-value.webp';
const acbPriceSection = '/media/price-and-value/price-and-value.webp';
const imfPriceSection = '/media/price-and-value/value-smiling-laptop.webp';
const fscPriceSection = '/media/price-and-value/value-smiling.webp';
const nacPriceSection = '/media/price-and-value/value-tea.webp';
const berPriceSection = '/media/price-and-value/value-smiling.webp';
const vbcPriceSection = '/media/price-and-value/value-tea.webp';
const ryrPriceSection = '/media/price-and-value/value-tea.webp';
const vepPriceSection = '/media/price-and-value/price-and-value.webp';
const dk2PriceSection = '/media/price-and-value/value-smiling-laptop.webp';
const dk5PriceSection = '/media/price-and-value/value-smiling-laptop.webp';

const Fiteness_Enthusisasts = '/media/useCase/Fitness_Enthusisasts.webp';
const Busy_Professionals = '/media/useCase/busy-professional-writing.webp';
const Go_Getters = '/media/useCase/active-parent-hiking.webp';
const Active_Adults = '/media/useCase/running-beach.webp';
const Running_blackman = '/media/useCase/running-black-man.webp';
const Think_Go_Getter = '/media/useCase/think-factor-go-getter.webp';
const YearWellness = '/media/useCase/Wellness.webp';
const Fitness = '/media/useCase/Fitness-new.webp';
const active_Adult_FireFighter = '/media/useCase/active-adult-firefighter.webp';
const low_Energy = '/media/useCase/busy.webp';
const prevent_Health_Seaker = '/media/useCase/wellness-yoga.webp';
const Busy_Professionals_Shipping =
  '/media/useCase/busy-professional-shipping.webp';
const Wellness_Sunset = '/media/useCase/wellness-sunset.webp';
const Running_In_RedShirt = '/media/useCase/running-in-red-shirt.webp';
const Busy_Professionals_Tablet =
  '/media/useCase/busy-professional-tablet.webp';
const Concern_About_Aging = '/media/useCase/wellness-yoga.webp';
const Wellness_Hiking = '/media/useCase/welness-hiking-cliff.webp';
const Running_In_Beach = '/media/useCase/running-beach.webp';
const Benefits_Hiking = '/media/useCase/benefits-hiking.webp';
const Bone_Advocate = '/media/useCase/bone-advocate.webp';
const Biking_View = '/media/useCase/biking-view.webp';
const Active_Parent_Hiking = '/media/useCase/active-parent-hiking.webp';
const Busy_Professionals_Papers =
  '/media/useCase/busy-professional-papers.webp';

//overview PDP new product
const antioxidantOverview =
  '/media/overview/Rhodiola-rosea-compressed-2048x1848.jpg';

// New Product images
const thinkFactorBottle = '/media/products/think-factor.webp';
const antioxidantsBottle = '/media/products/rf-antioxidants.webp';
const fullSpectrumBottle = '/media/products/full-spectrum-e.webp';
const immuneFactorsBottle = '/media/products/immune-factors.webp';
const nacBottle = '/media/products/nac.webp';
const berberineBottle = '/media/products/berberine.webp';
const vitaminBComplexBottle = '/media/products/vitamin-b-complex.webp';
const redYeastRiceBottle = '/media/products/red-yeast-rice.webp';
const vesselProtectionBottle = '/media/products/vessel-protection.webp';
const vitaminD3K25000Bottle = '/media/products/vitamin-d3-k2-5.webp';
const vitaminD3K22000Bottle = '/media/products/vitamin-d3-k2-2.webp';

//Highlight section
const immuneLeafIcon = '/media/pdp-highlights/immune-leave-icon.svg';
const tnkbeakerIcon = '/media/pdp-highlights/conical-flask.svg';
const tnkDiamondIcon = '/media/pdp-highlights/flower.svg';
const tnkWheatIcon = '/media/pdp-highlights/vegan.svg';
const acbbeakerIcon = '/media/pdp-highlights/hand-coins.svg';
const acbDiamondIcon = '/media/pdp-highlights/shield-half.svg';
const acbWheatIcon = '/media/pdp-highlights/orbit.svg';
const fscbeakerIcon = '/media/pdp-highlights/salad.svg';
const fscDiamondIcon = '/media/pdp-highlights/hand-coins.svg';
const fscWheatIcon = '/media/pdp-highlights/wheat.svg';
const imfbeakerIcon = '/media/pdp-highlights/salad.svg';
const imfDiamondIcon = '/media/pdp-highlights/conical-flask.svg';
const imfWheatIcon = '/media/pdp-highlights/dollar.svg';
const nacbeakerIcon = '/media/pdp-highlights/hand-coins.svg';
const nacDiamondIcon = '/media/pdp-highlights/leaf.svg';
const nacWheatIcon = '/media/pdp-highlights/orbit.svg';
const berbeakerIcon = '/media/pdp-highlights/conical-flask.svg';
const berDiamondIcon = '/media/pdp-highlights/hand-coins.svg';
const berWheatIcon = '/media/pdp-highlights/test-tube-diagonal.svg';
const vbcbeakerIcon = '/media/pdp-highlights/salad.svg';
const vbcDiamondIcon = '/media/pdp-highlights/vegan.svg';
const vbcWheatIcon = '/media/pdp-highlights/hand-coins.svg';
const ryrbeakerIcon = '/media/pdp-highlights/heart-pulse.svg';
const ryrDiamondIcon = '/media/pdp-highlights/zap.svg';
const ryrWheatIcon = '/media/pdp-highlights/hand-coins.svg';
const vepbeakerIcon = '/media/pdp-highlights/salad.svg';
const vepDiamondIcon = '/media/pdp-highlights/hand-coins.svg';
const vepWheatIcon = '/media/pdp-highlights/focus.svg';
const vd3k2beakerIcon = '/media/pdp-highlights/salad.svg';
const vd3k2DiamondIcon = '/media/pdp-highlights/convenience.svg';
const vd3k2WheatIcon = '/media/pdp-highlights/hand-coins.svg';
const vd3k5beakerIcon = '/media/pdp-highlights/salad.svg';
const vd3k5DiamondIcon = '/media/pdp-highlights/convenience.svg';
const vd3k5WheatIcon = '/media/pdp-highlights/hand-coins.svg';

//Home page category section
const jointAndPainSupport = '/media/category-section/joint-pain.webp';
const brainAndMentalSupport = '/media/category-section/brain-mental.webp';
const energyAndVitalitySupport = '/media/category-section/energy-vitality.webp';
const heartAndCirculatorySupport =
  '/media/category-section/heart-circulatory.webp';
const immuneAndSystemSupport = '/media/category-section/immune-system.webp';
const sleepAndRelaxationSupport =
  '/media/category-section/sleep-relaxation.webp';
export const productImages = {
  [productsKeyConstants.RF_QUICKSTART]: rfPainRelief,
  [productsKeyConstants.RF_60CT]: rfPainRelief,
  [productsKeyConstants.RF_60CT_SINGLE]: rfPainRelief,
  [productsKeyConstants.RF_ENERGY1]: rfGoFactor,
  [productsKeyConstants.RF_ENERGY2]: rfGoFactor,
  [productsKeyConstants.RF_ENERGY3]: rfGoFactor,
  [productsKeyConstants.RF_CALM]: rfZenFactor,
  [productsKeyConstants.RF_SLEEP]: rfZFactor,
  [productsKeyConstants.RF_RELIEF_FACTOR_QS]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_60_CT]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_60_CT_CA]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_60_CT_SINGLE]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_60_CT_CA_SINGLE]: rfPainRelief,
  [productsKeyConstants.RF_GO_FACTOR]: rfGoFactor,
  [productsKeyConstants.RF_GO_FACTOR_SINGLE]: rfGoFactor,
  [productsKeyConstants.RF_Z_FACTOR]: rfZFactor,
  [productsKeyConstants.RF_Z_FACTOR_SINGLE]: rfZFactor,
  [productsKeyConstants.RF_ZEN_FACTOR]: rfZenFactor,
  [productsKeyConstants.RF_ZEN_FACTOR_CA]: rfZenFactor,
  [productsKeyConstants.RF_ZEN_FACTOR_SINGLE]: rfZenFactor,
  [productsKeyConstants.RF_ZEN_FACTOR_CA_SINGLE]: rfZenFactor,
  [productsKeyConstants.RF_THINK_FACTOR]: thinkFactorBottle,
  [productsKeyConstants.RF_THINK_FACTOR_SINGLE]: thinkFactorBottle,
  [productsKeyConstants.DE_ANTIOXIDANTS]: antioxidantsBottle,
  [productsKeyConstants.DE_ANTIOXIDANTS_SINGLE]: antioxidantsBottle,
  [productsKeyConstants.RF_FULL_SPECTRUM_E]: fullSpectrumBottle,
  [productsKeyConstants.RF_FULL_SPECTRUM_E_SINGLE]: fullSpectrumBottle,
  [productsKeyConstants.RF_IMMUNE_FACTOR]: immuneFactorsBottle,
  [productsKeyConstants.RF_IMMUNE_FACTOR_SINGLE]: immuneFactorsBottle,
  [productsKeyConstants.RF_N_ACETYL_CYSTEINE]: nacBottle,
  [productsKeyConstants.RF_N_ACETYL_CYSTEINE_SINGLE]: nacBottle,
  [productsKeyConstants.RF_BERBERINE]: berberineBottle,
  [productsKeyConstants.RF_BERBERINE_SINGLE]: berberineBottle,
  [productsKeyConstants.RF_RED_YEAST_RICE]: redYeastRiceBottle,
  [productsKeyConstants.RF_RED_YEAST_RICE_SINGLE]: redYeastRiceBottle,
  [productsKeyConstants.RF_VESSEL_PROTECTION]: vesselProtectionBottle,
  [productsKeyConstants.RF_VESSEL_PROTECTION_SINGLE]: vesselProtectionBottle,
  [productsKeyConstants.RF_VITAMIN_B_COMPLEX]: vitaminBComplexBottle,
  [productsKeyConstants.RF_VITAMIN_B_COMPLEX_SINGLE]: vitaminBComplexBottle,
  [productsKeyConstants.RF_VITAMIN_D_K2]: vitaminD3K22000Bottle,
  [productsKeyConstants.RF_VITAMIN_D_K2_SINGLE]: vitaminD3K22000Bottle,
  [productsKeyConstants.RF_VITAMIN_D_K5]: vitaminD3K25000Bottle,
  [productsKeyConstants.RF_VITAMIN_D_K5_SINGLE]: vitaminD3K25000Bottle,
  [productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC_SINGLE]: rfPainRelief,
  [productsKeyConstants.RF_RELIEF_FACTOR_60_CT_NEC]: rfPainRelief,
  115: rfPainRelief,
  116: rfPainRelief,
  117: rfZenFactor,
  118: rfGoFactor,
  119: rfZFactor,
  75: newVitaminD,
  98: newVitaminC,
  150: rfPainRelief,
  151: rfPainRelief,
  145: rfPainRelief,
  146: rfPainRelief,
  152: rfThinkFactor,
  turmericImage: turmericImageStr,
  researchImage: researchImage,
  turmericImageStr,
  rfbug: RFBug,
  rfShareLogo: RFShareLogo,
  RFQSTablets,
  painRelief,
};

export const ingredientImages = {
  omega,
  icariin,
  curcumin,
  resveratrol,
};

export const assets = {
  SLPGaba,
  SLPLtheanine,
  SLPMelatonin,
  SLPVitaminD,
  SLPWhySleepBG,
  SLPCloud,
};

export const marketingPageAssets = {
  mkOmega3,
  mkIcariin,
  mkTurmeric,
  mkResveratrol,
  happyWomen,
};

export {
  yourSolutionImage,
  quickstartImage,
  happyCoupleImage,
  joggingGuysImage,
  sleepingCoupleImage,
  turmericBowlImage,
  veteranImage,
  reviewImage,
  // new site images
  painRelief,
  goFactor,
  zenFactor,
  zFactor,
  veteranImg,
  leaf1,
  leaf2,
  leaf3,
  leaf4,
  rfFooterLogo,
  whyReliefFactorImg,
  whyReliefFactorImgBlur,
  customerStoriesImg,
  miniCartRelief,
  resourceArticle,
  resourceArticleBody,
  rfLogoPng,
  // Product Cards
  pillsPacket,
  pillsWithShadow,
  pillWithShadow,
  rfPainRelief,
  rfThinkFactor,
  rfGoFactor,
  rfZFactor,
  rfZenFactor,
  rfZenFactor1,
  rfZFactor1,
  rfGoFactor1,
  deAntioxidants,
  rfFullSpectrumE,
  immuneFactor,
  nAcetyleCystine,
  howItWorksImg1,
  howItWorksImg2,
  howItWorksImg3,
  graph_howItWorks,
  Icariin,
  Resveratrol,
  Turmeric,
  Omega3,
  fullBleedImg,
  fullBleedImgmd,
  fullBleedImgSm,
  //
  timelineImg1,
  timelineImg2,
  timelineImg3,
  resveratrolImg,
  fishOilImg,
  turmericImg,
  icariinImg,
  //
  RFQSTabletsOld,
  RF_Icon,
  //
  testimonialsReliefImg,
  testimonialsZenImg,
  testimonialsGoImg,
  testimonialszImg,
  //ingredients
  curcumin,
  icariin,
  omega,
  resveratrol,
  taurine,
  bcomplex,
  caffeine,
  phosphatidylserine,
  passionflower,
  ltheanine,
  gaba,
  vitamind,
  melatonin,
  echinaceaAngustipholia,
  andrographis,
  echinaceaPurpurea,
  berberis,
  astragalus,
  cticoline,
  lutein,
  zeaxanthin,
  choline,
  folate,
  inositol,
  niacin,
  paraAminobenzoic,
  riboflavin,
  thiamin,
  vitaminB6,
  vitaminB12,
  ascorbicAcid,
  pantothenic,
  biotin,
  molybdenum,
  AcetyleCystine,
  selenium,
  CoQ10,
  redYeastExtract,
  VEPfolate,
  VEPvitaminB6,
  VEPvitaminB12,
  berberisAristata,
  aztecMarigold,
  Selenium,
  bitartrate,
  dunaliella,
  tocotrienol,
  vitaminA,
  vitaminE,
  vitaminD,
  vitaminK2,
  calcium,
  catalase,
  bioflavonoid,
  greenTea,
  hesperidin,
  magnesium,
  quercetin,
  antioxidantResveratrol,
  rutin,
  sod,
  vitaminC,
  // story
  sufferingWithPain,
  findRelief,
  discoverReliefFactor,
  zenSuccess,
  meditationPose,
  stressedOut,
  noEnergy,
  twoEnergyDrinks,
  studying,
  sleepless,
  sleeping,
  rejuvenated,
  // Body
  painReliefBody,
  zenFactorBody,
  goFactorBody,
  zFactorBody,
  // Getting Started
  gettingStartedRFPills,
  //Review
  reviewHeaderDesktop,
  reviewHeaderTab,
  reviewHeaderMobile,
  pillTwo,
  pillFive,
  // Support
  supportHeaderDesktop,
  supportHeaderTab,
  // Testimonial PDP
  testimonialFullImg1,
  testimonialMbImg1,
  testimonialFullImg2,
  testimonialFullImg3,
  testImg1,
  testImg2,
  testImg3,
  testImg4,
  testImg5,
  testImg6,
  testImg7,
  testImg8,
  testImg9,
  // Free gift
  VitamindBottle,
  // New Products
  thinkFactorBottle,
  antioxidantsBottle,
  fullSpectrumBottle,
  immuneFactorsBottle,
  nacBottle,
  berberineBottle,
  vitaminBComplexBottle,
  redYeastRiceBottle,
  vesselProtectionBottle,
  vitaminD3K25000Bottle,
  vitaminD3K22000Bottle,
  //overview new product PDP
  thinkfactorOverviewBackground,
  antioxidantOverviewBackground,
  fullSpectrumOverviewBackground,
  immuneOverviewBackground,
  immuneOverviewBottle,
  nAcetyleOverviewBackground,
  berberineOverviewBackground,
  vitBOverviewBackground,
  redYeastOverviewBackground,
  vesselProtectOverviewBackground,
  vitDK2OverviewBackground,
  vitDK5OverviewBackground,
  //how it works new product
  thinkHowItWrks,
  acbHowItWrks,
  fscHowItWrks,
  imfHowItWrks,
  nacHowItWrks,
  berHowItWrks,
  vbcHowItWrks,
  ryrHowItWrks,
  vepHowItWrks,
  dk2HowItWrks,
  dk5HowItWrks,
  //Price section PDP new products
  tnkPriceSection,
  acbPriceSection,
  imfPriceSection,
  fscPriceSection,
  nacPriceSection,
  berPriceSection,
  vbcPriceSection,
  ryrPriceSection,
  vepPriceSection,
  dk2PriceSection,
  dk5PriceSection,
  antioxidantOverview,
  Fiteness_Enthusisasts,
  Busy_Professionals,
  YearWellness,
  Fitness,
  Go_Getters,
  Active_Adults,
  Running_blackman,
  Think_Go_Getter,
  active_Adult_FireFighter,
  low_Energy,
  prevent_Health_Seaker,
  Busy_Professionals_Shipping,
  Wellness_Sunset,
  Running_In_RedShirt,
  Busy_Professionals_Tablet,
  Concern_About_Aging,
  Wellness_Hiking,
  Running_In_Beach,
  Benefits_Hiking,
  Bone_Advocate,
  Biking_View,
  Active_Parent_Hiking,
  Busy_Professionals_Papers,
  //highlight section 10 new product
  tnkbeakerIcon,
  tnkDiamondIcon,
  tnkWheatIcon,
  acbbeakerIcon,
  acbDiamondIcon,
  acbWheatIcon,
  fscbeakerIcon,
  fscDiamondIcon,
  fscWheatIcon,
  imfbeakerIcon,
  imfDiamondIcon,
  imfWheatIcon,
  immuneLeafIcon,
  nacbeakerIcon,
  nacDiamondIcon,
  nacWheatIcon,
  berbeakerIcon,
  berDiamondIcon,
  berWheatIcon,
  vbcbeakerIcon,
  vbcDiamondIcon,
  vbcWheatIcon,
  ryrbeakerIcon,
  ryrDiamondIcon,
  ryrWheatIcon,
  vepbeakerIcon,
  vepDiamondIcon,
  vepWheatIcon,
  vd3k2beakerIcon,
  vd3k2DiamondIcon,
  vd3k2WheatIcon,
  vd3k5beakerIcon,
  vd3k5DiamondIcon,
  vd3k5WheatIcon,

  //Home page category section
  jointAndPainSupport,
  brainAndMentalSupport,
  energyAndVitalitySupport,
  heartAndCirculatorySupport,
  immuneAndSystemSupport,
  sleepAndRelaxationSupport,
};
